import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/** Regenerate authored V2 copy and queue its render through Phase A. */
export const useSynthesizeVideo = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (videoId: string) =>
      apiClient.post(`videos/${videoId}/synthesize`, {}),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.videos.all() });
    },
  });
  return { synthesizeVideoAsync: mutation.mutateAsync };
};
